/* eslint-disable react/prop-types */
import React from "react";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import CardComponent from "app/common/CardComponent";
import ScopeDoughnutComponent from "./ScopeDoughnutComponent";

const useStyles = makeStyles((theme) => ({
  cardBody: {
    height: "calc(100% - 24px)",
    overflow: "hidden",
  },
  cardRow: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    height: "33%",
    overflow: "hidden",
  },
  secondColumn: {
    paddingLeft: "10px",
  },
  chartContainer: {
    position: "relative",
    [theme.breakpoints.up("xs")]: {
      overflow: "hidden",
      flexGrow: "1",
      height: "105px",
    },
    [theme.breakpoints.up("lg")]: {
      overflow: "hidden",
      flexGrow: "1",
      height: "100%",
    },
  },
  componentTitle: {
    fontWeight: "bold",
    fontSize: "14px",
    [theme.breakpoints.up("xl")]: {
      fontSize: "16px",
    },
  },
}));

function HistorySummaryComponent({ scopeSummaryData }) {
  const classes = useStyles();
  const catalogSlice = useSelector((state) => state.catalog);
  const retailersSlice = useSelector((state) => state.retailers);
  const areasSlice = useSelector((state) => state.areas);

  const productsIncluded = scopeSummaryData.distinct_count_product_id || 0;

  const productsData = {
    labels: ["Included SKUs", "Excluded SKUs"],
    text: `${parseFloat(
      (
        (100 * productsIncluded) /
        Object.keys(catalogSlice.products).length
      ).toFixed(1)
    )}%`,
    datasets: [
      {
        data: [
          productsIncluded,
          Object.keys(catalogSlice.products).length - productsIncluded,
        ],
        backgroundColor: ["#666666", "#eaeaea"],
      },
    ],
  };

  const retailersIncluded = scopeSummaryData.distinct_count_retailer_id || 0;

  const retailersData = {
    labels: ["Included Retailers", "Excluded Retailers"],
    text: `${parseFloat(
      ((100 * retailersIncluded) / Object.keys(retailersSlice).length).toFixed(
        1
      )
    )}%`,
    datasets: [
      {
        data: [
          retailersIncluded,
          Object.keys(retailersSlice).length - retailersIncluded,
        ],
        backgroundColor: ["#666666", "#eaeaea"],
      },
    ],
  };

  const areasIncluded = scopeSummaryData.distinct_count_area_id || 0;

  const areasData = {
    labels: ["Included areas", "Excluded areas"],
    text: `${parseFloat(
      ((100 * areasIncluded) / Object.keys(areasSlice).length).toFixed(1)
    )}%`,
    datasets: [
      {
        data: [areasIncluded, Object.keys(areasSlice).length - areasIncluded],
        backgroundColor: ["#666666", "#eaeaea"],
      },
    ],
  };

  return (
    <CardComponent
      title={
        <Typography variant="body1" className={classes.componentTitle}>
          Selected scope
        </Typography>
      }
      body={
        <div className={classes.cardBody}>
          <Grid
            item
            container
            xs={12}
            sm={12}
            md={12}
            lg={12}
            className={classes.cardRow}
          >
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              lg={6}
              className={classes.chartContainer}
            >
              <ScopeDoughnutComponent data={productsData} />
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              lg={6}
              className={classes.secondColumn}
            >
              <Typography variant="body2">
                <b>SKUs</b>
              </Typography>
              <Typography variant="caption">{productsIncluded}</Typography>
            </Grid>
          </Grid>
          <Grid
            item
            container
            xs={12}
            sm={12}
            md={12}
            lg={12}
            className={classes.cardRow}
          >
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              lg={6}
              className={classes.chartContainer}
            >
              <ScopeDoughnutComponent data={retailersData} />
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              lg={6}
              className={classes.secondColumn}
            >
              <Typography variant="body2">
                <b>Retailers</b>
              </Typography>
              <Typography variant="caption">{retailersIncluded}</Typography>
            </Grid>
          </Grid>
          <Grid
            item
            container
            xs={12}
            sm={12}
            md={12}
            lg={12}
            className={classes.cardRow}
          >
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              lg={6}
              className={classes.chartContainer}
            >
              <ScopeDoughnutComponent data={areasData} scope="Promotions" />
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              lg={6}
              className={classes.secondColumn}
            >
              <Typography variant="body2">
                <b>Areas</b>
              </Typography>
              <Typography variant="caption">{areasIncluded}</Typography>
            </Grid>
          </Grid>
        </div>
      }
    />
  );
}

export default HistorySummaryComponent;
